import { Control } from "react-hook-form";

import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";

import InputFormField from "components/input-form-field";
import SelectFormField from "components/select-form-field";
import EnumDataSource from "utils/enum-data-source.util";

import { InventoryType } from "../../inventory-product-form/inventory-product-form.component";
import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";

const ears = {
  L: "Left",
  R: "Right"
};

export const EAR_TYPES = new EnumDataSource(ears);

export type EarmoldSpecificationValues = {
  ear?: string | null;
  canal_length?: string | null;
  venting?: string | null;
  material?: string | null;
  options?: string | null;
  additional_notes: string;
};

export const EMPTY_EARMOLD_SPECIFICATION: EarmoldSpecificationValues = {
  ear: "",
  canal_length: "",
  venting: "",
  material: "",
  options: "",
  additional_notes: ""
};

type EarmoldSpecificationFormProps = {
  inventoryType: InventoryType;
  control: Control<InventoryProductSpecificationValues, object>;
  sx?: SxProps;
};

export default function EarmoldSpecificationForm({
  inventoryType,
  control,
  sx
}: EarmoldSpecificationFormProps) {
  return (
    <Stack spacing={4} sx={{ width: "100%", ...sx }}>
      <Stack direction="row" spacing={2}>
        <SelectFormField
          name="earmold.ear"
          label="Ear"
          control={control}
          required={inventoryType === "clinicStock"}
          options={EAR_TYPES.getOptions()}
        />
        <InputFormField
          name="earmold.canal_length"
          label="Canal Length"
          placeholder=""
          control={control}
          sx={{ ml: 0 }}
        />
        <InputFormField
          name="earmold.venting"
          label="Venting"
          placeholder=""
          control={control}
          sx={{ ml: 0 }}
        />
      </Stack>
      <InputFormField
        name="earmold.material"
        label="Material"
        placeholder=""
        control={control}
        sx={{ ml: 0, maxWidth: "50%" }}
      />
      <InputFormField
        name="earmold.options"
        label="Options"
        placeholder=""
        control={control}
        sx={{ ml: 0 }}
      />
      <InputFormField
        name="earmold.additional_notes"
        label="Additional notes"
        control={control}
        sx={{ ml: 0 }}
        multiline
      />
    </Stack>
  );
}
